import React from "react";
import { HomePageProductProps } from "../../types/ProductList";
import {
  TextBox,
  Title,
  ProductDetailsBox,
  RootContainer,
  ImageBox,
  ButtonContainer,
  ExploreButton,
} from "./productBanner.styles";
import { useNavigate } from "react-router-dom";
import colors from "../../theme/Colours";

export const ProductBannerCard: React.FC<HomePageProductProps> = ({
  id,
  name,
  abv,
  ibu,
  image,
  showBuyButton,
  onClick,
}) => {
  const orgId = localStorage.getItem("orgId");
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/maltora-customer/products/product/${id}`);
  };

  return (
    <RootContainer image={image}>
      <ImageBox image={image} />
      <TextBox>
        <ProductDetailsBox>
          <span>ABV {abv}%</span>
          <span>
            IBU {ibu}
            {ibu !== "N/A" ? "%" : ""}
          </span>
        </ProductDetailsBox>
        <Title variant="h5">{name.toLocaleUpperCase()}</Title>
      </TextBox>
      <ButtonContainer>
        <ExploreButton
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            (onClick || handleNavigate)();
          }}
        >
          Know more
        </ExploreButton>
      </ButtonContainer>
    </RootContainer>
  );
};
